const steps = [
  {
    num: "01",
    title: "Phase préliminaire",
    hours: "2h",
    desc: "Analyse de votre situation, définition de vos besoins et de votre cadre d'accompagnement",
  },
  {
    num: "02",
    title: "Phase d'investigation",
    hours: "9h",
    desc: "Exploration de vos compétences, aptitudes, motivations et pistes professionnelles",
  },
  {
    num: "03",
    title: "Phase de conclusion",
    hours: "2h",
    desc: "Synthèse personnalisée, plan d'action concret et feuille de route",
  },
];

const StepsSection = () => {
  const scrollToForm = () => {
    document.getElementById("hero-form")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="section-padding bg-background">
      <div className="container mx-auto text-center">
        <h2 className="mb-4 text-3xl font-extrabold md:text-4xl">
          Un Accompagnement Structuré en 3 Étapes
        </h2>
        <p className="mx-auto mb-12 max-w-xl text-muted-foreground">
          Durée totale : 13h — Réparti sur 3 mois à votre rythme
        </p>

        <div className="mx-auto grid max-w-4xl gap-8 md:grid-cols-3">
          {steps.map((s, i) => (
            <div key={s.num} className="relative text-center">
              {i < steps.length - 1 && (
                <div className="absolute right-0 top-10 hidden h-0.5 w-full translate-x-1/2 bg-border md:block" />
              )}
              <div className="relative mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-primary text-2xl font-extrabold text-primary-foreground">
                {s.num}
              </div>
              <h3 className="mb-1 text-lg font-bold">{s.title}</h3>
              <span className="mb-3 inline-block rounded-full bg-secondary px-3 py-0.5 text-xs font-semibold text-secondary-foreground">
                {s.hours}
              </span>
              <p className="text-sm text-muted-foreground">{s.desc}</p>
            </div>
          ))}
        </div>

        <button onClick={scrollToForm} className="btn-cta-sm mt-12">
          Je démarre mon bilan →
        </button>
      </div>
    </section>
  );
};

export default StepsSection;
